import React from "react";
import { MainContainer } from "../components";
import { useNavigate } from "react-router-dom";
import AboutHead from '../assets/AboutUs/aboutus.jpg';
import Placeholder from "../assets/Team/Placeholder.png";

import { SiReactos } from "react-icons/si";
import { ImFlag } from "react-icons/im";
import { FaLayerGroup } from "react-icons/fa";
import QuickResponse from "../assets/AboutUs/QuickResponse.svg";
import Experienced from "../assets/AboutUs/Experienced.svg";
import NoGeekSpeak from "../assets/AboutUs/NoGeekSpeak.svg";
import BusinessSavvy from "../assets/AboutUs/BusinessSavvy.svg";
import OneStopShop from "../assets/AboutUs/OneStopShop.svg";
import Satisfaction from "../assets/AboutUs/Satisfaction.svg";


export default function About() {
  const navigate = useNavigate();

  const aboutList = [
    {
      id: 1,
      title: "OUR MISSION",
      description:
        "Building on our technologies and competencies creating value for our customers. We’ll achieve this by focusing on the intersection of our client’s emerging solar needs and the acceleration of business and technological change in the solar industry.",
      icon: <SiReactos className="text-2xl text-secondary-color" />,
    },
    {
      id: 2,
      title: "OUR VALUES",
      description:
        "Our values are the guiding principles upon which Particle Solar Power (OPC) Pvt Ltd was founded and how we strive to conduct our solar business on a daily basis. Values establish our view of the world as we shape the future of solar energy. They determine how we treat each solar project.",
      icon: <ImFlag className="text-2xl text-secondary-color" />,
    },
    {
      id: 3,
      title: "OUR APPROACH & CULTURE",
      description:
        "Our drive for exceptional service delivery in the solar industry is built on the belief that we are nothing if you are not satisfied with our solar solutions. Our passion for helping you achieve your solar goals, no matter what, is what truly differentiates us from other solar competitors.",
      icon: <FaLayerGroup className="text-2xl text-secondary-color" />,
    },
  ];
  

  const Reasons = [
    {
      id: 1,
      title: "Efficient Solutions",
      description:
        "Our team excels in providing efficient solar module mounting solutions, ensuring optimal performance and swift issue resolution.",
      icon: QuickResponse,
    },
    {
      id: 2,
      title: "Decades of Expertise",
      description:
        "With over 5 years of expertise in the solar industry, we bring a wealth of experience in diverse technologies and project scopes.",
      icon: Experienced,
    },
    {
      id: 3,
      title: "Clear Communication",
      description:
        "We believe in transparent communication. Our team ensures that technical aspects are explained in clear and understandable terms.",
      icon: NoGeekSpeak,
    },
    {
      id: 4,
      title: "Strategic Solutions",
      description:
        "Our approach involves designing and implementing solar solutions that align with your business goals, ensuring maximum benefits.",
      icon: BusinessSavvy,
    },
    {
      id: 5,
      title: "Comprehensive Services",
      description:
        "As your comprehensive solar partner, we manage all aspects of solar module mounting, including hardware, software, and technology needs.",
      icon: OneStopShop,
    },
    {
      id: 6,
      title: "Customer Satisfaction Commitment",
      description:
        "We are dedicated to your satisfaction. Our commitment is to go the extra mile, ensuring hassle-free and problem-free experiences for our clients.",
      icon: Satisfaction,
    },
  ];


  const Teams = [
    {
      id: 1,
      image: Placeholder,
      name: "Ved Dixit",
      description: "Founder and Director",
      mobileNo: "+919718965965",
    },
    {
      id: 2,
      image: Placeholder,
      name: "Navneet Sharma",
      description: "AVP-Sales",
      mobileNo: "+918005675884",
    },
    {
      id: 3,
      image: Placeholder,
      name: "Sandeep Parasher",
      description: "Project Manager",
      mobileNo: "+919899590456",
    },
    {
      id: 4,
      image: Placeholder,
      name: "Sonu Kumar",
      description: "Production Manager",
      mobileNo: "+919582542656",
    },
  ];

  return (
    <MainContainer>

      {/* TOP IMAGE */}
      <div className="text-gray-200 relative w-full overflow-hidden">
        <div className="w-full">
          <img src={AboutHead} alt="About" className='w-full  bg-cover' />
        </div>

        <div className="flex flex-col w-full absolute top-8 left-10 lg:top-28 lg:left-60">
          <p className="text-2xl md:text-7xl font-bold ">
            About Us
          </p>
          <p className="text-xs md:text-3xl">
            We innovate, supply, and support solar mounts nationwide.
          </p>
        </div>
      </div>

      {/* HEADING */}
      <div className="px-8 lg:px-28 flex flex-col items-center mt-8">
        <p className="text-lg text-center">Our Vision</p>
        <p className="text-xl lg:text-5xl font-extrabold text-center mb-2">Fostering Solar Excellence</p>
        <p className="text-lg lg:text-2xl text-center mb-3">Propelling the Wide-scale Adoption of Rooftop Solar Solutions through Particle Solar Power's Innovations and Commitment.</p>
        <div>
          <div className="h-[3px] bg-primary-color w-20 mb-5" />
        </div>


        <p className="text-lg lg:text-xl text-gray-700 text-center ">
          Particle Solar Power (OPC) Pvt Ltd is renowned as a leading provider of Solar Module Mounting Solutions. Our journey in mounting structures began in 2017, and we specialize in designing, manufacturing, and supplying Hot Dipped Galvanized or Post Galvanized, Pre-Galvanized, and Aluminum PV Module Mounting structures. Serving as a one-stop solution provider for all Solar Module Mounting challenges, we have a dedicated core team that has successfully supplied for projects exceeding 30+ MW across India. Committed to ensuring the highest quality raw materials, top-notch finished products, and timely delivery, we take pride in our contributions to the solar power industry.
        </p>
      </div>

      {/* our misson */}
      <div className="w-full flex flex-col sm:flex-row gap-2  px-10 py-5 mt-10 ">
        {/* Card */}
        {aboutList &&
          aboutList.map((item) => {
            return (
              <div
                key={item.id}
                className="border-[1px] rounded-lg px-5 py-3 flex flex-col gap-2 items-start justify-center"
              >
                <div className="">{item.icon}</div>
                <div>
                  <p className="text-lg font-semibold">{item.title}</p>
                </div>
                <div>
                  <p className="">{item.description}</p>
                </div>
              </div>
            );
          })}
      </div>

      {/* WHY CHOOSE US */}
      <div className="w-full flex flex-col gap-3 items-center justify-center mt-10">
        <div>
          <p className="font-medium text-xl">WHY CHOOSE US</p>
        </div>
        {/* <div>
            <p className="text-2xl">6 REASONS TO PARTNER WITH US</p>
          </div> */}
        <div>
          <div className="h-[3px] bg-primary-color w-20" />
        </div>
        <div className="w-full flex flex-row gap-3 px-5 py-3  flex-wrap justify-between">
          {/* card */}
          {Reasons &&
            Reasons.map((item) => {
              return (
                <div
                  key={item.id}
                  className="w-full lg:w-[32%] md:w-[48%] px-2 py-2 flex flex-row "
                >
                  <div className="w-[50%] ">
                    <img
                      src={item.icon}
                      alt={item.techName}
                      className="h-10"
                    />
                  </div>
                  <div>
                    <div>
                      <p className="text-lg font-semibold">{item.title}</p>
                    </div>
                    <div>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="w-full px-5 flex items-center text-center justify-center">
          <p className="font-medium">
            Stop wasting time and money. Contact Us Now
          </p>
        </div>
      </div>

      {/* OUR PEOPLE */}
      <div className="w-full flex flex-col gap-3 items-center justify-center text-center pt-5 pb-10">
        <div className="w-full flex items-center text-center justify-center px-2">
          <p className="text-xl">GREAT PRODUCT STARTS WITH A GREAT TEAM</p>
        </div>
        <div>
          <div className="h-[3px] bg-primary-color w-20" />
        </div>

        <div className="w-full flex flex-col lg:flex-row gap-5 items-center justify-center px-5 py-2  ">
          {Teams &&
            Teams.map((item) => {
              return (
                <div className="w-64 flex flex-col items-center justify-center ">
                  <div className=" z-10 relative top-16">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="h-32 w-32 rounded-full border-4 border-transparent hover:border-secondary-color hover:transform hover:translate-y-[-10px] transition-transform"
                    />
                  </div>
                  <div className="relative w-full flex flex-col items-center  ">
                    <div className=" h-40 w-40 rounded-full bg-white absolute bottom-28" />

                    <div className="w-full h-48 flex flex-col items-center justify-end pb-4  bg-gray-200">
                      <p className="font-bold text-lg ">{item.name}</p>
                      <p className="text-secondary-color ">
                        {item.description}
                      </p>
                      <p>{item.mobileNo}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </MainContainer>
  );
}
